export const generateYearOptions = (): string[] => {
  const currentYear: number = new Date().getFullYear();
  const yearOptions: string[] = [];

  for (let year = 2023; year <= currentYear; year++) {
    yearOptions.push(year.toString());
  }

  return yearOptions;
};
